let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1SO1W")).then(() => parcelRequire('cgt7H'));